/* © CNES */
import React from 'react';
import {
  EXCLUDED_DYNAMIC_KEYS,
  mappingProductAttributes,
} from '../utils/mappingProductAttributes';

interface ProductDetailsProps {
  productDetails: Record<string, any>;
}

/**
 * ProductDetails Component
 *
 * This component displays product details, both static and dynamic attributes.
 *
 *
 * @param {ProductDetailsProps} props - The properties containing product data.
 * @returns {JSX.Element} The rendered component displaying product details.
 */
export const ProductDetails: React.FC<ProductDetailsProps> = ({
  productDetails,
}) => {
  if (!productDetails) return null;

  // Clés déjà définies dans le mapping
  const knownKeys = new Set(mappingProductAttributes.map(({ key }) => key));

  // Génération des attributs dynamiques
  const dynamicAttributes = Object.keys(productDetails)
    .filter((key) => !knownKeys.has(key) && !EXCLUDED_DYNAMIC_KEYS.has(key))
    .map((key) => ({ key }));

  return (
    <>
      {/* Affichage des attributs connus */}
      {mappingProductAttributes.map(
        ({ key, label }) =>
          productDetails[key] !== null &&
          productDetails[key] !== undefined && (
            <div className="HeaderRow" key={key}>
              <p className="RowValue">{productDetails[key]}</p>
              <p className="RowLabel">{label}</p>
            </div>
          )
      )}

      {/* Affichage des attributs dynamiques */}
      {dynamicAttributes.map(({ key }) => (
        <div className="HeaderRow" key={key}>
          <p className="RowValue">{JSON.stringify(productDetails[key])}</p>
          <p className="RowLabel">{key.replace(/[_-]/g, ' ')}</p>
        </div>
      ))}
    </>
  );
};
